export const HEADER = {
  height: "64px",
} as const;

export const FILTER = {
  width: "330px",
  height: "100%",
  formHeight: `calc(100vh - ${HEADER.height} - 32px)`,
  labelWidth: "60px",
  inputWidth: "230px",
  inputHeight: "34px",
} as const;

export const MOBILE_BREAKPOINT = "(max-width: 375px)" as const;
